import './promotion-item.scss';

export const PromotionItem = ({ discount, description, imageUrl, color }) => (
  <div className="promotion-item" style={{ background: color }}>
    {imageUrl && <img className="promotion-item__image" src={imageUrl} alt="promotion" />}
    <div className="promotion-item__badge">
      <span className="promotion-item__percent">{discount}%</span>
      <span className="promotion-item__label">Discount</span>
    </div>
    {description && <span className="promotion-item__description">{description}</span>}
  </div>
);
